/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";
import SearchIconWithPeople from "../../../assets/svg/SearchIconWithPeople";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterFriendLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
} from "../../../contants";
import useParamsQuery from "../../../hooks/useParamsQuery";
import {
  SET_SELECTED_FRIEND,
  SET_SELECTED_FRIEND_FROM_SEARCH,
} from "../../../redux/actionTypes/dashboard";
import { selectOSKeysByUserRole } from "../../../redux/selectors/user";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import styles from "../../member/MemberSearch/MemberSearch.styles";
import OrganizationSearch from "../../member/MemberSearch/OrganizationSearch";
import {
  getFilters,
  getFormattedQuery,
  getFriendRoutePath,
  handleDependencyFilter,
  performOperation,
} from "../utils";
import FriendTable from "../FriendTable/FriendTable";
import Friends from "../../../services/api/friend";
import FriendDeactivateModal from "./FriendDeactivateModal";
import Toast from "../../../components/common/Toast";
import PersonalDetailsSearch from "./PersonalDetailsSearch";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function SearchFriend() {
  const TITLE = "Friend Search - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false); // deactivate modal
  const [openResultModal, setOpenResultModal] = useState(false); // search result modal
  const [showSearchResult, setShowSearchResult] = useState(false); // track search attempt
  const allowModalRef = useRef(false); // ✅ open modal only after user-initiated search
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const selectedFriend = useSelector(
    (store) => store.view_friends.selectedFriend
  );
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);

  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const onModalToggle = () => setOpenModal((prev) => !prev);

  const clearFormRef = () => {
    Object.keys(AppliedFilterFriendLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getFriendRoutePath()}?${query}`);
    } else {
      navigate(`${getFriendRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  // helper: check if there is any real filter (exclude pagination keys)
  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const fetchSearchData = async (
    queryParams,
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
        pageNumber,
        pageSize,
      });

      const { content, totalPages, totalElements, number } =
        await Friends.searchFriend(formattedQuery);

      setTimeout(() => {
        setSearchData(content);
        setCurrentPage(number);
        setTotalPages(totalPages);
        setTotalElements(totalElements);
        setPageSize(pageSize);
        setIsLoading(false);

        if (content.length > 0) {
          // ✅ Open modal only when user actually hit Search (ref avoids race)
          if (allowModalRef.current) {
            setOpenResultModal(true);
            setShowSearchResult(true);
            allowModalRef.current = false; // reset after opening
          }
        } else {
          setShowToast({
            severity: "error",
            message: "No data found ",
          });
          setOpenResultModal(false);
          setShowSearchResult(false);
          allowModalRef.current = false; // ensure not opening later
        }
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    // Check if all filters empty
    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    formData.pageNumber = 0;
    formData.pageSize = Constants.DEFAULT_PAGE_SIZE;

    const query = queryString.stringify(formData);
    document.dispatchEvent(new Event(EVENT_NAME));

    // ✅ Mark user-initiated search BEFORE URL change (ref is synchronous)
    allowModalRef.current = true;

    // Update URL
    updateSearchParam(query);

    // ✅ Force fetch immediately to avoid first-click race with effect
    fetchSearchData(formData, formData.pageNumber, formData.pageSize);
  };

  // React to URL changes (refresh, back/forward, pagination)
  useEffect(() => {
    const queryObject = getQueryObject();

    // No query → close modal & reset
    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    // Only pagination or effectively no filters → close & clean
    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      if (
        queryObject.pageNumber !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam(); // strip params
      }
      return;
    }

    // We have real filters in URL → fetch (modal opening is gated by ref)
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params.pageNumber, params.pageSize);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getFilters:", err);
        setAppliedFilters([]); // fallback to avoid crash
      }
    } else {
      setAppliedFilters([]); // reset when no query/filters
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectFriendForTransfer = (friend) => {
    dispatch({
      type: SET_SELECTED_FRIEND,
      payload: friend,
    });
    navigate("/friend/create-friend-transfer");
  };

  const onFriendSelect = (friend) => {
    navigate(`/friend/details/${friend.friendId}`);
  };

  const onSelectFriend = (data) => {
    if (data) {
      dispatch({
        type: SET_SELECTED_FRIEND_FROM_SEARCH,
        payload: data,
      });
      navigate(`/members/create/${data.friendId}`);
    }
  };

  const onFriendStatusToggle = (friend) => {
    dispatch({
      type: SET_SELECTED_FRIEND,
      payload: friend,
    });
    onModalToggle();
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params.pageNumber, params.pageSize);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false; // stop auto-open
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <Button
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </Button>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Search by Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </Button>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left cluster: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Friends: {totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <Button
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </Button>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <FriendTable
                  searchData={searchData}
                  onSelectFriendForTransfer={onSelectFriendForTransfer}
                  onFriendSelect={onFriendSelect}
                  hasPermission={hasPermission}
                  onFriendStatusToggle={onFriendStatusToggle}
                  onSelectFriend={onSelectFriend}
                />
              </div>

              {/* Pagination */}
              <div style={{ marginTop: "20px" }}>
                <Pagination
                  totalPages={totalPages}
                  totalResults={totalElements}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onChange={onPaginationClick}
                  onPageSizeClick={onPageSizeClick}
                />
              </div>
            </>
          ) : showSearchResult ? null : (
            // fallback (Choose your Search Filter)
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "30px 0",
                color: "#777",
              }}
            >
              <SearchIconWithPeople width={100} />
              <p>Choose your Search Filter</p>
            </div>
          )}
        </Modal>

        {/* Deactivate Modal */}
        <Modal open={openModal} onClose={onModalToggle}>
          <FriendDeactivateModal
            onClose={onModalToggle}
            onSearchClick={onRefresh}
            selectedFriend={selectedFriend}
          />
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default SearchFriend;
